export const createConfig = ({ experiments, httpClient, getAuthorization, getBaseUrl, }) => {
    return {
        experiments,
        httpClient,
        getAuthorization,
        getBaseUrl,
    };
};
//# sourceMappingURL=createConfig.js.map